import Headroom from 'headroom.js';
let __headroomInstance;
document.addEventListener('DOMContentLoaded', () => {
  __headroomInstance = initPrincipalHeader();
});

function freezeNav() {
  __headroomInstance.freeze();
}

function unfreezeNav() {
  __headroomInstance.unfreeze();
}

function setHeaderSpacerHeight(height, headerSpacer) {
  headerSpacer.style.height = `${height}px`;
}

function calcHeaderSpacerHeight(domEl) {
  const headerSpacer = document.querySelector('.header-spacing');
  if (!headerSpacer) return;

  setHeaderSpacerHeight(domEl.offsetHeight, headerSpacer);

  window.onresize = () => {
    setHeaderSpacerHeight(domEl.offsetHeight);
  };
}

function initPrincipalHeader() {
  const myHeader = document.querySelector('.contyquim-header');
  if (!myHeader) return;
  
  calcHeaderSpacerHeight(myHeader);
  var options = {
    tolerance: {
      up: 0,
      down: 15
    }
  };
  const headerHeadroom = new Headroom(myHeader, options);
  headerHeadroom.init();

  return headerHeadroom;
}

export { freezeNav, unfreezeNav };
